import ChartWidget from './ChartWidget';

export default ChartWidget;
